module.exports = __webpack_public_path__ + "static/media/20150613_125523.dfa0e499.jpg";